module.exports = __webpack_public_path__ + "img/logo.7c1e4e9c.png";